import { render, staticRenderFns } from "./personnelDetails.vue?vue&type=template&id=3651e805&scoped=true&"
import script from "./personnelDetails.vue?vue&type=script&lang=js&"
export * from "./personnelDetails.vue?vue&type=script&lang=js&"
import style0 from "./personnelDetails.vue?vue&type=style&index=0&id=3651e805&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3651e805",
  null
  
)

export default component.exports